module.exports = __webpack_public_path__ + "img/logo_fh-kiel.ed77510e.png";